import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Dialog, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { DatePickerComponent, TimePickerComponent } from '@syncfusion/ej2-react-calendars';
import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useGetDriversForTransferOptionsQuery, useGetOrderTransferOptionsQuery, useSaveOrderTransferOptionsMutation } from '../../../features/Dispatch/TripDispatchSlice';
import { Typeahead } from 'react-bootstrap-typeahead';
import errorHandler from '../../hooks/ErrorHanlder';
import swal from 'sweetalert';

const TransferPickup = (props) => {
    const [readyDate, setReadyDate] = useState(new Date().toISOString().split('T')[0]);
    const [readyTime, setReadyTime] = useState(new Date().toLocaleTimeString('en-GB').slice(0, 5));
    const [notes, setNotes] = useState('');
    const [selectedOption, setSelectedOption] = useState("1");
    const [selectedDock, setSelectedDock] = useState('');
    const [dockDriver, setDockDriver] = useState(null);
    const { data: orderTransferOptions } = useGetOrderTransferOptionsQuery();
    const [saveOrderTransferOptions] = useSaveOrderTransferOptionsMutation();
    const { data: driversForTransferOptions } = useGetDriversForTransferOptionsQuery();
    const docks = driversForTransferOptions?.data?.find(driver => driver.driverNumber == dockDriver)?.docks || [];
    const isDivision = driversForTransferOptions?.data?.find(driver => driver.driverNumber == dockDriver)?.type === 'Interdivision';
    const [selectedService, setSelectedService] = useState(null);
    const [selectedVehicle, setSelectedVehicle] = useState(null);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setReadyTime(new Date().toLocaleTimeString('en-GB').slice(0, 5)); // updates time every minute
    //     }, 60000); 

    //     return () => clearInterval(interval);
    // }, []);

    const statusMap = {
        'O': 'Open',
        'L': 'Loading',
        'OUT': 'Outbound',
        'IN': 'Inbound',
        'C': 'Completed',
    }

    useEffect(() => {
        if (props.showPickupTransfer) {
            setReadyDate(new Date().toISOString().split('T')[0]);
            setReadyTime(new Date().toLocaleTimeString('en-GB').slice(0, 5));
            setNotes('');
            setSelectedOption("1");
            setSelectedDock('');
            setDockDriver(null);
            setSelectedVehicle(null);
            setSelectedService(null);
        }
    }, [props.showPickupTransfer]);

    const handleTransmit = async () => {
        if (props.selectedDriverForTransfer?.type === 'Interdivision') {
            if (!selectedVehicle) {
                toast.error('Please select a vehicle', { position: 'top-center' });
                return;
            }
            if (!selectedService) {
                toast.error('Please select a service', { position: 'top-center' });
                return;
            }
        }
        if (selectedOption === "1" && !dockDriver) {
            toast.error('Please select a dock driver', { position: 'top-center' });
            return;
        }
        if (selectedOption === "1" && isDivision && !selectedDock) {
            toast.error('Please select a dock', { position: 'top-center' });
            return;
        }
        const transmitData = {
            divisionId: props.divisionId,
            selectedTransferOptionId: selectedOption,
            orderNumber: props.orderNumber,
            orderID: props.orderID,
            isAtPickupSide: true,
            driverNumber: props.selectedDriverForTransfer?.driverNumber,
            driverType: props.selectedDriverForTransfer?.type,
            dockDriver: dockDriver || props.selectedDriverForTransfer?.driverNumber,
            interdivisionDock: selectedDock || null,
            date: readyDate,
            time: readyTime,
            notesSection: notes,
            vehicleID: selectedVehicle,
            serviceID: selectedService,
        }
        try {
            const response = await saveOrderTransferOptions(transmitData).unwrap();
            props.setShowPickupTransfer(false)
            // toast.success(response.message, { position: 'top-center' });
            swal({title: "Success", text: response.message, icon: "success", button: "OK",});
            props.getAllOpenTripOrders(props.divisionId);
            if (props.selectedTrip) {
                props.getTripOrdersClassification({ tripStatus: statusMap[props.selectedTrip?.tripStatusCode], tripId: props.selectedTrip?.tripID, divisionId: props.divisionId });
            }
            setNotes('');
        } catch (error) {
            errorHandler(error);
        }
    };
    return (
        <Dialog PaperProps={{ sx: { minWidth: { sm: '100%', md: "700px" } } }} maxWidth="lg" open={props.showPickupTransfer} onClose={() => props.setShowPickupTransfer(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
            <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: '#bf2527', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Enter ready date and instructions
                <CloseRoundedIcon onClick={() => props.setShowPickupTransfer(false)} />
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className='mb-3 mt-3'>
                        <div style={{ color: '#244da1', fontWeight: 'bold' }} >Select an option to transmit order {props.orderNumber}:</div>
                        {/* <span style={{ color: '#bf2527', }}>Driver must be selected before using special instructions</span> */}
                    </div>
                    { props.selectedDriverForTransfer?.type === 'Interdivision' &&
                        <div className='d-flex mb-3 gap-2'>
                            <div className='w-100'>
                                <span>Select Vehicle:</span>
                                <Form.Select
                                    aria-label="Select Vehicle"
                                    onChange={(e) => setSelectedVehicle(e.target.value)}
                                    value={selectedVehicle}
                                >
                                    <option value=''>Select Vehicle</option>
                                    {props.vehiclesByDivision?.data?.map((vehicle) => (
                                        <option key={vehicle.vehicleId} value={vehicle.vehicleId}>{vehicle.vehicleType}</option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div className='w-100'>
                                <span>Select Service:</span>
                                <Form.Select
                                    aria-label="Select Service"
                                    onChange={(e) => setSelectedService(e.target.value)}
                                    value={selectedService}
                                >
                                    <option value=''>Select Service</option>
                                    {props.servicesByDivision?.data?.map((service) => (
                                        <option key={service.serviceID} value={service.serviceID}>{service.service}</option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>
                    }
                    <div className='d-flex mb-3 gap-2'>
                        <div className='w-100' >
                            <span>Ready Date:</span>
                            <div className="timepicker">
                                <DatePickerComponent
                                    id="datepicker"
                                    name="date"
                                    value={readyDate}
                                    placeholder="Select a date"
                                    change={(e) => setReadyDate(e.target.value)}
                                    format="MM/dd/yyyy"
                                />
                            </div>
                        </div>
                        <div className='w-100' >
                            <span>Ready Time:</span>
                            <div className="timepicker">
                                <TimePickerComponent id="time" placeholder="Open time" name="OfficeHour" value={readyTime} format={'hh:mm a'} />
                            </div>
                        </div>
                    </div>
                    <div className='mb-2'>
                        <div className='d-flex justify-content-between'>
                            <div className='d-flex align-items-center gap-2'>
                                <input
                                    style={{ transform: 'scale(1.3)', cursor: 'pointer' }}
                                    type="radio"
                                    name="options"
                                    id='1'
                                    value="1"
                                    checked={selectedOption === "1"}
                                    onChange={(e) => setSelectedOption(e.target.value)}
                                />
                                <span>Pickup from Shipper and return to dock</span>
                            </div>
                            <Typeahead
                                disabled={selectedOption !== "1"}
                                id="basic-typeahead-single"
                                labelKey={(option) => `${option.driverNumber} (${option.type})`}
                                onChange={(selected) => {
                                    if (selected.length > 0) {
                                        setDockDriver(selected[0].driverNumber);
                                    } else {
                                        setDockDriver(null);
                                    }
                                }}
                                options={driversForTransferOptions?.data?.filter(driver => driver.type !== 'Employee')}
                                placeholder="Select Agent/Interliner/Division"
                                selected={
                                    dockDriver
                                        ? [
                                            driversForTransferOptions?.data?.find(
                                                driver => driver.driverNumber === dockDriver
                                            )
                                        ]
                                        : []
                                }
                            />
                            {isDivision &&
                                <Form.Select
                                    aria-label="Floating label select example"
                                    style={{ width: '30%' }}
                                    onChange={(e) => setSelectedDock(e.target.value)}
                                    disabled={selectedOption !== "1"}
                                    value={selectedDock}
                                >
                                    <option value='0'>Select Dock</option>
                                    {docks.map((dock) => (
                                        <option key={dock.dockID} value={dock.dockID}>{dock.dockName}</option>
                                    ))}
                                </Form.Select>
                            }
                        </div>
                        {orderTransferOptions?.data?.filter(option => option.type === 'P' && option.id !== 1).map((option) => (
                            <div key={option.id} className='d-flex gap-2 pb-2'>
                                <input
                                    style={{ transform: 'scale(1.3)', cursor: 'pointer' }}
                                    type="radio"
                                    name="options"
                                    value={String(option.id)}
                                    checked={selectedOption === String(option.id)}
                                    onChange={(e) => {
                                        setDockDriver(null);
                                        setSelectedDock('');
                                        setSelectedOption(e.target.value)
                                    }}
                                    disabled={option.id === 5 && props.selectedDriverForTransfer?.type !== 'Interdivision'}
                                />
                                {option.transferOption}
                            </div>
                        ))
                        }
                    </div>
                    <textarea
                        className='transferNotes'
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        placeholder="Notes..."
                        style={{ width: '100%', height: '80px' }}
                    />
                    <div className='mt-2 d-flex justify-content-end'>
                        <Button className="btn-primary w-25" onClick={handleTransmit} autoFocus> Transmit</Button>
                    </div>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default TransferPickup;